const projectImages = {
  1: {
    avatar: require('../img/works/laje/laje_avatar.png'),
    gallery: [
      require('../img/works/laje/laje.gif'),
    ],
  },
  2: {
    avatar: require('../img/works/vereda/avatar_vereda.jpg'),
    gallery: [
      require('../img/works/vereda/vereda_full.png'),
    ],
  },
  3: {
    avatar: require('../img/works/app_receitas/app_receitas_avatar.png'),
    gallery: [
      require('../img/works/app_receitas/Receita_full.png'),
    ],
  },
  4: {
    avatar: require('../img/works/the_box/full.png'),
    gallery: [
      require('../img/works/the_box/full.png'),
    ],
  },
  5: {
    avatar: require('../img/works/sistema_solar/solar.png'),
    url: 'https://www.youtube.com/watch?v=ztVV54sPOns&t=609s',
  },
  6: {
    avatar: require('../img/works/shopping_cart/shoppin_cart_avatar.png'),
    gallery: [
      require('../img/works/shopping_cart/shoppin_cart.png'),
    ],
  },
  7: {
    avatar: require('../img/works/cicloturismo_agencia/cicloturismo.png'),
    gallery: [
      require('../img/works/cicloturismo_agencia/cicloturismo.png'),
    ],
  },
  8: {
    avatar: require('../img/works/super_trunfo/super_trunfo_avatar.png'),
    gallery: [
      require('../img/works/super_trunfo/super_trunfo.png'),
    ],
  },
  9: {
    avatar: require('../img/works/wallet/wallet_avatar.png'),
    gallery: [
      require('../img/works/wallet/wallet.png'),
    ],
  },
  10: {
    avatar: require('../img/works/bhl/bhl.jpg'),
    gallery: [
      require('../img/works/bhl/bhl.jpg'),
    ],
  },
};

export default projectImages;
